module.exports = __webpack_public_path__ + "static/media/freccia_dx_scheda.b6df01c2.svg";